// extracted by mini-css-extract-plugin
export default {"formContainer":"styles_formContainer__V1a7s","label":"styles_label__CohpJ","input":"styles_input__wd2bh","btn_submit":"styles_btn_submit__ZDhEd"};